export enum CampaignType {
  TOKENS = "tokens",
}
